/**
 * Upgrade http:// asset URLs to https:// when the page is served over HTTPS.
 * Safety net for API-returned URLs if backend config was cached with http://.
 */
export function secureAssetUrl(url) {
  if (!url || typeof url !== 'string') {
    return url;
  }

  if (typeof window !== 'undefined' && window.location.protocol === 'https:' && url.startsWith('http://')) {
    return `https://${url.slice(7)}`;
  }

  return url;
}

export function normalizeSiteConfig(config) {
  if (!config || typeof config !== 'object') {
    return config;
  }

  const urlFields = [
    'favicon_url',
    'logo_light_url',
    'logo_dark_url',
    'logo_icon_url',
  ];

  const next = { ...config };

  urlFields.forEach((key) => {
    if (next[key]) {
      next[key] = secureAssetUrl(next[key]);
    }
  });

  if (next.hero) {
    next.hero = {
      ...next.hero,
      bg_image_url: secureAssetUrl(next.hero.bg_image_url),
    };
  }

  if (next.sponsored) {
    next.sponsored = {
      ...next.sponsored,
      image_url: secureAssetUrl(next.sponsored.image_url),
    };
  }

  return next;
}
